// @ts-ignore
/* eslint-disable */
import { request } from 'src/utils/request';

export async function getChannel(params?: { isAll?: boolean }) {
  return request<Record<string, any>>('/api/v1/channel', {
    method: 'GET',
    params,
  });
}

export async function postChannel(data: { device_id: string; channel_id: string }) {
  return request<Record<string, any>>('/api/v1/channel', {
    method: 'POST',
    data,
  });
}

export async function putChannel(data: { device_id: string; channel_id: string; id: string }) {
  return request<Record<string, any>>(`/api/v1/channel`, {
    method: 'PUT',
    data,
  });
}

export async function deleteChannel(data: { ids: string[] }) {
  return request<Record<string, any>>(`/api/v1/channel`, {
    method: 'DELETE',
    data,
  });
}

export async function postStreamsPlay(data: { channel_id: string; device_id: string }) {
  return request<Record<string, any>>(`/api/v1/streams/play`, {
    method: 'POST',
    data,
  });
}

export async function deleteStreams(data: { id: string }) {
  return request<Record<string, any>>(`/api/v1/streams/${data.id}`, {
    method: 'DELETE',
  });
}

export async function getIpcAlarm(params?: { isAll?: boolean }) {
  return request<Record<string, any>>('/api/v1/ipc-alarm', {
    method: 'GET',
    params,
  });
}

export async function deleteIpcAlarm(data: { ids: string[] }) {
  return request<Record<string, any>>(`/api/v1/ipc-alarm`, {
    method: 'DELETE',
    data,
  });
}
